import {
  ButtonModule,
  SpacingModule,
  TitleModule,
  GridModule,
  PaddingModule,
  InteractiveMediaCardGridModule,
  InteractiveMediaCardModule,
  InteractiveMediaCardImageModule,
  InteractiveMediaCardContentModule,
} from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { InteractiveMediaCardGridComponent } from './interactive-media-cards-grid.component';

@NgModule({
  declarations: [InteractiveMediaCardGridComponent],
  imports: [
    BrSdkModule,
    ButtonModule,
    CommonModule,
    TitleModule,
    PaddingModule,
    SpacingModule,
    GridModule,
    InteractiveMediaCardGridModule,
    InteractiveMediaCardModule,
    InteractiveMediaCardImageModule,
    InteractiveMediaCardContentModule,
  ],
  exports: [InteractiveMediaCardGridComponent],
  entryComponents: [InteractiveMediaCardGridComponent],
})

/**
 * Index Cards Module
 */
export class IndexCardsModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Interactive Media Card': InteractiveMediaCardGridComponent,
    };
  }
}
